import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';

/**
 * Delete Case Form Use Case
 * Deletes a case form and updates state
 */
@Injectable({ providedIn: 'root' })
export class DeleteCaseFormUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(id: string): Observable<void> {
    this._state.setSavingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.deleteCaseForm(id).pipe(
      tap(() => {
        this._state.removeCaseForm(id);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message || 'Failed to delete case form';
        this._state.setErrorCaseForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setSavingCaseForm(false))
    );
  }
}
